import React, {Fragment, useCallback, useEffect, useState} from 'react';
import styled from 'styled-components';

import { Field} from '@atlaskit/form';
import Textfield from '@atlaskit/textfield';
import { Checkbox } from '@atlaskit/checkbox';

const Wrapper = styled.div`
    width: 100%;    
    display: grid;
    justify-content: center;
    padding-top: 30px;
`;

const ButtonWrapper = styled.div`   
    display: column;
    width: 700px;
    padding-top: 20px;
    padding-bottom: 15px;
`;

const FieldWrapper = styled.div`
    width: 500px;
    padding-top: 15px;
`;

export const SaveModel = ({ nextDisabled, name, save , currentTime, activeStep, processLabel='Process'}) => {
    const [isCheckedSaveEventLog, setIsCheckedSaveEventLog] = useState(true);
    const [projectName, setProjectName] = useState('');

    React.useEffect(() => {
//        setEntityCSV('Issue')
        nextDisabled(true)
    }, []);
        
    const onChangeSaveEventLog = useCallback((event) => {
        setIsCheckedSaveEventLog((current) => !current);
    }, []);

    const changeProjectName = (value) => {
        nextDisabled(false)
        setProjectName(value.target.value)
    }

    useEffect(() => {
        name(projectName)
    }, [projectName]);

    useEffect(() => {
        save(isCheckedSaveEventLog)
    }, [isCheckedSaveEventLog]);

    useEffect(() => {
        if (activeStep === 2) {
            nextDisabled(true)
        }
    }, [activeStep])

    return (
        <Wrapper>

            <FieldWrapper>
                <Field name="issue_type" label={`Analysis Model Name`}>
                    {({fieldProps: {id, onChange, ...rest}}) => (
                    <Fragment>
                        <Textfield 
                            name="basic"  
                            aria-label="default text field"
                            onChange={(value) => {
                                changeProjectName(value); // Explicit call here
                            }}
                        />
                    </Fragment>
                    )}
                </Field>
            </FieldWrapper>

        </Wrapper>
        
    );
};

/*
            <FieldWrapper>
                <Checkbox
                     isChecked={isCheckedSaveEventLog}
                     onChange={onChangeSaveEventLog}
                     label={'Save Event Log'}
                     name="external_save"
                   />
            </FieldWrapper>
*/